// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608140734/js/" + chunkId + "." + {"44":"d14b2bb4","225":"cd810d4b","481":"389502c2","486":"ece643ea","770":"d20c151c"}[chunkId] + ".0.20506133568764984.chunk.js";
};